/**
 * date:2022/3/8
 * des:修改密码组件
 * author:lhq
 * */
import React, {Component} from "react";
import {Form, Input, Modal, message, Tooltip, Button} from "antd";
import CmForm from "../CmForm/CmForm";
import BaseComponent from "../../base/BaseComponent";
import {logout} from "../../actions";
import ComPassword from "./components/ComPassword";
import {changeLoginStatus} from "../../actions";
import Background from "../../containers/login/changeDept/image/公司banner.png";

const {Password} = Input;
export default class AmendPassword extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            level: "2"
        };
    }

    getPublicKey() {
        this.request({
            url: "/cm-sites-sys/login/getPublicKey",
            method: "post",
            callBack: (res) => {
                if (res) {
                    this.setState({publicKey: res});
                } else {
                    message.error("获取公钥失败！");
                }
            }
        });
    }

    updatePassword(oldPass, newPass) {
        let body = {};
        const {publicKey} = this.state;
        body.publicKey = publicKey;
        body.oldPass = oldPass;
        body.newPass = newPass;
        this.request({
            url: "/cm-sites-sys/user/updatePassword",
            method: "post",
            body,
            callBack: (res) => {
                if (res) {
                    message.success("密码修改成功，请重新登录", 2, () => {
                        this.setState({visible: false});
                        logout("", false, () => {
                            changeLoginStatus({status: "false"});
                        })
                        window.location.reload()
                    });
                } else {
                    message.error("修改失败！");
                }
            }
        });
    }

    show(allData) {
        // 获取密码强度
        this.getPasswordLevel((res) => {
            this.state.level = res;
            this.setState({visible: true, oldPass: "", newPass: "", reConfirmPass: ""}, () => {
                if (!this.props.isShowFirstLogin) {
                    this.getPublicKey();
                }
            });
        });
        if (allData) {
            this.allData = allData;
        }
    }

    getPasswordLevel = (call) => {
        this.request({
            url: '/cm-sites-sys/user/getCurrentLevel',
            callBack: (res) => {
                if (res) {
                    call && call(res)
                }
            }
        })
    };

    onUserChange(obj) {
        this.setState({...obj});
    }

    checkoutForm() {
        let {oldPass, newPass, reConfirmPass, publicKey} = this.state;
        message.destroy();
        if (!oldPass) {
            message.error("请输入原始密码！");
            return false;
        }
        if (!newPass) {
            message.error("请输入新设密码！");
            return false;
        }
        if (newPass.length < 7) {
            message.error("新设密码长度过短！");
            return false;
        }
        if (newPass.length > 20) {
            message.error("新设密码长度过长！");
            return false;
        }
        if (newPass.trim().indexOf(' ') > -1 || newPass.trim() == '') {
            message.error("新设密码中间不可以有空格！");
            return false;
        }
        if (!reConfirmPass) {
            message.error("请输入确认密码！");
            return false;
        }
        if (newPass !== reConfirmPass) {
            message.error('新设密码和确认密码输入不一致！');
            return false;
        }
        if (this.state.level === "0") {
            if (!(/^[0-9a-zA-Z._~!@#$^&*]{7,20}$/.test(newPass))) {
                message.error("密码为7-20字符，可使用数字，字母，特殊字符（._~!@#$^&*）！");
                return false;
            }
        } else if (this.state.level === "1") {
            if (!(/((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)^\S{7,20}$/.test(newPass))) {
                message.error("密码为7-20字符，至少包含2种字符格式，可使用数字，字母，特殊字符（._~!@#$^&*）！");
                return false;
            }
        } else if (this.state.level === "2") {
            if (!(/(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%&*~()-+=]+$)(?![0-9\\W_!@#$%^&*()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`()-+=]{6,30}$/.test(newPass))) {
                message.error("密码为7-20字符，至少包含3种字符格式，可使用数字，字母，特殊字符（._~!@#$^&*）！");
                return false;
            }
        }
        // if (!(/^[0-9a-zA-Z._~! @#$^&*]{7,20}$/.test(newPass))) {
        //   message.error("密码为7-20字符，可使用数字，字母，特殊字符（._~!@#$^&*）！");
        //   return false;
        // }
        return true;

    }

    onOk = (e) => {
        e && (typeof e.preventDefault == 'function') && e.preventDefault();
        let {oldPass, newPass, reConfirmPass, publicKey} = this.state;
        let {
            pass: encryptionInitialPass = "",
            pass2: encryptionNewPass = ""
        } = window.encryption(oldPass, newPass, publicKey);
        let newPublicKey = window.encryption(oldPass, newPass, publicKey);
        let flag = this.checkoutForm();
        // 校验
        if (flag) {
            // 是首次登录修改密码页面点击确定
            if (this.props.isShowFirstLogin) {
                this.props.updatePasswordCall && this.props.updatePasswordCall(newPublicKey);
            } else {
                // 正常修改密码
                this.updatePassword(encryptionInitialPass, encryptionNewPass);
            }
        }
    };

    render() {
        let {visible} = this.state;
        return (
            <Modal
                visible={visible}
                title={"修改密码"}
                centered={true}
                width={440}
                // onOk={() => this.onOk()}
                onCancel={() => this.onCancel()}
                bodyStyle={{padding: 0}}
                maskClosable={false}
                maskStyle={this.props.isShowFirstLogin ? {backgroundImage: `url(${Background})`} : {}}
                destroyOnClose={true}
                footer={
                    <div style={{textAlign: 'center'}}>
                        <Button onClick={() => this.onCancel()}>取消</Button>
                        <Button
                            onClick={() => this.onOk()}
                            style={{backgroundColor: this.themeBgColor}}
                            className={"okBtn"}
                        >确定</Button>
                        <style>{`
                .okBtn{
                  color: #fff !important;
                }
                `}</style>
                    </div>
                }
            >
                <div style={{padding: 20}}>
                    {
                        this.props.isShowFirstLogin ? <div style={{
                            paddingLeft: '11px',
                            background: 'rgba(245, 108, 108, 0.1)',
                            lineHeight: '33px',
                            color: 'red',
                            marginBottom: '10px'
                        }}>{this?.allData?.status === 4023 ? this?.allData?.message : "首次登录，请您尽快修改密码"}
                        </div> : null
                    }
                    <form>
                        <CmForm onSubmit={this.onOk}>
                            <Form.Item
                                label={"原始密码"}
                                required={true}
                            >
                                <ComPassword
                                    id="password_1"
                                    placeholder="请输入原始密码"
                                    value={this.state.oldPass}
                                    onChange={e => this.onUserChange({oldPass: e.target.value})}
                                />
                            </Form.Item>
                            <Form.Item
                                label={"新设密码"}
                                required={true}
                            >
                                <ComPassword
                                    id="password_2"
                                    placeholder="请输入新设密码"
                                    value={this.state.newPass}
                                    onChange={e => this.onUserChange({newPass: e.target.value})}
                                />
                            </Form.Item>
                            <Form.Item
                                label={"确认密码"}
                                required={true}
                                value={this.state.reConfirmPass}
                            >
                                <ComPassword
                                    id="password_3"
                                    placeholder="请再次确认新设密码"
                                    value={this.state.reConfirmPass}
                                    onChange={e => this.onUserChange({reConfirmPass: e.target.value})}
                                />
                            </Form.Item>
                            <div style={{
                                paddingLeft: "11px",
                                background: "rgba(245, 108, 108, 0.1)",
                                lineHeight: "33px"
                            }}>
                  <span style={{color: "red"}}>注：{
                      this.state.level === "0" ? "密码长度为7-20个字符" :
                          this.state.level === "1" ? "密码设置为7-20个字符，至少包含2种字符格式" :
                              this.state.level === "2" ? "密码设置为7-20个字符，至少包含3种字符格式" : "密码长度为7-20个字符"
                  }</span>
                            </div>
                        </CmForm>
                        <button type={"submit"} style={{display: "none"}}/>
                    </form>
                </div>
            </Modal>
        );
    }

    // 取消
    onCancel = () => {
        this.setState({visible: false});
        this.props.handleCancel && this.props.handleCancel()
    }
}